var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRewardStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M13.284 2.5L2.5 13.284l8.216 8.216L21.5 10.716l-.514-7.702-7.702-.514z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.053,
    cy: 7.118,
    r: 1.5,
    stroke: props.color,
    transform: "rotate(90 17.053 7.118)"
  }));
}
export default SvgIconRewardStroke;